import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router';
import { Box, Typography, Alert, Button } from '@mui/material';
import { Login as LoginIcon } from '@mui/icons-material';
import { userManager } from '../oidc';
import oidcService from '../oidc';
import { colors } from '../../styles/theme';
import LoadingState from '../../components/states/LoadingState';

const SigninCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const callbackProcessed = useRef(false);

  useEffect(() => {
    const handleCallback = async () => {
      if (callbackProcessed.current) return;
      callbackProcessed.current = true;

      try {
        const user = await userManager.signinRedirectCallback();

        if (user) {
          setTimeout(() => {
            navigate('/', { replace: true });
          }, 1000);
        } else {
          throw new Error('Kein Benutzer nach Callback erhalten');
        }
      } catch (error) {
        setError(error instanceof Error ? error.message : 'Unbekannter Fehler');
      } finally {
        setIsLoading(false);
      }
    };

    handleCallback();
  }, [navigate]);

  if (isLoading) {
    return (
      <LoadingState
        fullScreen={true}
        message="Anmeldung wird verarbeitet..."
        subtitle="Bitte warten Sie einen Moment."
      />
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: `linear-gradient(135deg, ${colors.background} 0%, ${colors.primary} 100%)`,
          padding: 2,
        }}
      >
        <Box
          sx={{
            textAlign: 'center',
            background: colors.glass.backgroundStrong,
            padding: 4,
            borderRadius: 3,
            backdropFilter: 'blur(10px)',
            border: `1px solid ${colors.glass.borderSubtle}`,
            maxWidth: 400,
            width: '100%',
          }}
        >
          <Alert severity="error" sx={{ mb: 2, textAlign: 'left' }}>
            <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
              Anmeldung fehlgeschlagen
            </Typography>
            <Typography variant="body2">
              {error}
            </Typography>
          </Alert>

          <Button
            variant="outlined"
            startIcon={<LoginIcon />}
            onClick={() => oidcService.login()}
            sx={{ mt: 1, borderRadius: 2, textTransform: 'none' }}
          >
            Erneut versuchen
          </Button>
        </Box>
      </Box>
    );
  }

  return null;
};

export default SigninCallbackPage;
